// @ts-nocheck
import {
  CFG,
  DEFAULT_BINDS,
  ITEMS,
  ITEM_ORDER,
  KEYBINDS,
  KEY_TO_SLOT,
  REPORT_CATEGORIES,
  REPORT_CAT_ORDER,
  RESERVED_KEYS,
  ROBES,
  SLOT_ORDER,
  SPELLS,
  SPELLS_IN_SLOT,
  SPELL_AVAIL,
  SPELL_ORDER,
  SPELL_SCHOOLS,
  START_LOADOUT,
  UPGRADE,
  eventKeyLabel,
  isLocalDev,
  isTeammate,
  itemCost,
  keyLabelForSlot,
  rebuildKeyToSlot,
  saveKeybinds,
  spellAvail,
  spellInfo,
  spellSfx,
  spellShopDesc,
  spellShopPurchasable,
  teamColor,
  equippedTitleId,
} from "../data";
import {
  TAU,
  bindTabPresenceUnload,
  clamp,
  len,
  lerp,
  rand,
  rgba,
  shade,
  shrinkState,
  tabPresenceId,
  track,
} from "../util";
import {
  SPRITE_BRIM,
  armTimedProg,
  assetURL,
  bossImageByOct,
  drawArmChargeAccent,
  drawArmRangeTelegraph,
  drawEntityGroundShadow,
  drawSpellSprite,
  drawStar,
  fireballSpriteFXEnabled,
  healPodFromWire,
  makeWizardSprite,
  octIndex,
  pveBossName,
  refreshSpellSpriteDevFields,
  spellCastPopLayer,
  spellCastPopPose,
  spellSpriteAnimFrame,
  spellSpriteDevVisible,
  spellSpriteDrawSz,
  spellSpritePhaseDrawSz,
  spellSpritePhaseLife,
  spellSpritePhaseOpt,
  spellSpritePhaseReady,
  spellSpritePhaseSpec,
  spellSpriteSpec,
  updateSpellSpriteDevPanelVisibility,
  warlockImage,
  warlockImageByOct,
} from "../sprites";
import {
  AUDIO_CREDITS,
  Sound,
} from "../audio";
import {
  EMPTY_OPTS,
  Particle,
  Pillar,
  Player,
  Sigil,
  compact,
  recalcItems,
} from "../entities";
import {
  Net,
  Tip,
  angLerp,
  angleDiff,
  escapeHtml,
  fmtWhen,
  modeLabel,
  ordinal,
  setupUiButtonSounds,
  showConfirm,
  spellLabel,
  spellTipHTML,
  tipAttr,
} from "../net-ui";
import {
  lobbyInviteURL,
  parseLobbyInviteCode,
} from "../lobby";
import { resetNetJitter } from "../net-jitter";

import { Game } from "./game-base";

Game.prototype.goOnline = function (kind, code, opts = {}) {
    if (this.rejectIfAlphaClosed()) return;
    if (this.account && this.activeGame) {
      this.showFindError("You're already in a game.");
      return;
    }
    this.mode = "remote";
    this.testMode = false;
    this.spectating = false;
    this.clearRoundSpectate();
    this.spectateWatchId = null;
    this.spectateWatchPending = null;
    this.stopRoomPoll();
    // Custom create/join is not matchmaker queue — stale flags would swallow lobby updates.
    this._matchmake = null;
    this._inMatchQueue = false;
    this._readyCheck = false;
    this.hideReadyCheck();
    this.onQueueInviteEnd();
    track("online_game", { action: kind, spectate: !!opts.spectate }); // "create" | "join"
    Sound.stopAllFirewallLoops();
    this.players = []; this.projectiles = []; this.mines = []; this.sigils = []; this.healpods = []; this.blizzards = []; this.firewalls = []; this.hellrips = []; this.stickymines = []; this.icewalls = []; this.voidglass = []; this.nullSphereErupts = []; this.bossBeams = []; this.particles = []; this.snaps = [];
    this.shockwaves = []; this.beams = []; this.armPops = []; this.spellSpritePops = []; this.meteorCraters = []; this.floorBurns = []; this.bloodStains = []; this.plagueStains = []; this.frostStains = []; this.meteorNukeClouds = []; this.meteorNukeSwamps = []; this.meteorNukeFuses = [];
    this._intentionalClose = false;
    this.creds = null;
    this._reconnectTries = 0;
    const name = (document.getElementById("nameInput").value || "").trim();
    const title = equippedTitleId(this.account);
    if (this.net) this.net.close();
    this.net = new Net(this, (m) => this.onServerMsg(m));
    this.net.connect();
    if (kind === "create") {
      // Practice rooms are always private; they never appear in the lobby browser.
      const pub = (this._practice || this._sandbox) ? false : document.getElementById("publicToggle").checked;
      this._applyCreatePrefs = !this._practice && !this._sandbox;
      this.net.send({ t: "create", name, title, pub });
    } else {
      this.net.send({ t: "join", code, name, title, spec: !!opts.spectate });
    }
    this.showFindError("");
    document.getElementById(kind === "create" ? "createBtn" : "joinBtn").blur();
  }

Game.prototype.onDisconnect = function () {
    this.hidePing();
    // The gap while the socket is down is a reconnect artifact, not a freeze —
    // drop the snapshot-gap clock so it doesn't pollute the delivery metric.
    if (this.frameHealth) this.frameHealth.resetSnapClock();
    resetNetJitter(this);
    if (this._inMatchQueue) {
      this._inMatchQueue = false;
      this._matchmake = null;
      this.hideReadyCheck();
      this.mode = "local";
      this.setMatchQueueSearching(false);
      if (!this._intentionalClose) {
        this.showMatchmaker();
        this.showMmError("Disconnected from server.");
      }
      this.ensureMenuNet();
      return;
    }
    if (this._intentionalClose) return;
    if (this.mode === "local" && !this.creds) {
      this.net = null;
      setTimeout(() => this.ensureMenuNet(), 2000);
      return;
    }
    // Try to reconnect to the same room/seat if we have credentials. The window
    // is sized to outlast the server's restored-room hold: the server keeps a
    // restored match alive for ~5 min (resumeWaitMax = 300s) waiting for players
    // to return, so the client retries for at least that long (80 attempts: a
    // short backoff ramp to a 4s cap ≈ 5 min) instead of giving up while the
    // seat is still being held.
    if (this.mode === "remote" && this.creds && this._reconnectTries < 80) {
      const delay = Math.min(500 * this._reconnectTries, 4000);
      clearTimeout(this._reconnDelayTO);
      this._reconnDelayTO = setTimeout(() => this.attemptReconnect(), delay);
      return;
    }
    this.mode = "local";
    this.showMenu();
    this.showMenuError("Disconnected from server.");
  }

Game.prototype.ensureMenuNet = function () {
    if (this.net) return;
    if (this.mode !== "local") return;
    if (this._inMatchQueue) return;
    this._intentionalClose = false;
    this.net = new Net(this, (m) => this.onServerMsg(m));
    this.net.connect();
  }

Game.prototype.attemptReconnect = function () {
    if (!this.creds) return; // an err reply may have cleared the seat mid-backoff
    this._reconnectTries++;
    const el = document.getElementById("reconnecting");
    el.textContent = `Reconnecting… (${this._reconnectTries})`;
    el.classList.remove("hidden");
    this.net = new Net(this, (m) => this.onServerMsg(m));
    this.net.connect();
    const c = this.creds;
    this.net.send({ t: "rejoin", code: c.code, token: c.token, name: c.name, title: equippedTitleId(this.account) });
    // If we don't resync within a few seconds (server still coming up, or a
    // half-open socket), drop via dropStale so onDisconnect fires and schedules
    // the next attempt — plain close() would null onclose and stall the loop.
    clearTimeout(this._reconnTO);
    this._reconnTO = setTimeout(() => { if (this.net) this.net.dropStale(); }, 2800);
  }

Game.prototype.onResynced = function () {
    this._reconnectTries = 0;
    clearTimeout(this._reconnTO);
    clearTimeout(this._reconnDelayTO);
    document.getElementById("reconnecting").classList.add("hidden");
  }

// checkFeVersion compares the server's frontend asset version (sent in every
// catalog) to the bundle this page loaded (window.WLK_V). A mismatch means a
// deploy shipped new client code while this tab kept running the old one — so
// we schedule a reload to pick it up. This is what keeps an auto-reconnected
// client from talking stale frontend to a freshly deployed server after a
// breaking client change.
Game.prototype.checkFeVersion = function (serverBuild) {
    const mine = (typeof window.WLK_V === "string") ? window.WLK_V : "";
    // Dev builds carry the literal placeholder / "dev" — never reload then.
    if (!serverBuild || !mine || mine === "__V__" || mine === "dev") return;
    if (serverBuild === mine) {
      // Current: clear any stale reload marker so a future deploy can reload again.
      try { sessionStorage.removeItem("wlkReloadedFor"); } catch (e) {}
      this._fePendingReload = null;
      return;
    }
    this._fePendingReload = serverBuild;
    this.maybeApplyFeUpdate();
  }

// maybeApplyFeUpdate reloads to pick up new frontend code, but only when the
// player isn't in an active match — reloading mid-match re-downloads the WASM
// and interrupts play (and a deploy that restored the match would otherwise
// trigger this the moment the player reconnects). We defer through the whole
// match (rounds and shop alike) and apply it at match-over or back in the menu;
// the old bundle keeps working in the meantime because the wire protocol stays
// backward-compatible. After the reload, tryResumeSession reconnects into the
// same game. A sessionStorage guard prevents a reload loop if a stale cache
// keeps serving the old bundle.
Game.prototype.maybeApplyFeUpdate = function () {
    const build = this._fePendingReload;
    if (!build) return;
    const inMatch = this.mode === "remote" && !this.spectating &&
      (this.state === "countdown" || this.state === "bossintro" ||
       this.state === "playing" || this.state === "roundover" || this.state === "shop");
    if (inMatch) return;
    let already = "";
    try { already = sessionStorage.getItem("wlkReloadedFor") || ""; } catch (e) {}
    if (already === build) return; // already tried for this version; don't loop
    try { sessionStorage.setItem("wlkReloadedFor", build); } catch (e) {}
    this.showToast("Updating to the latest version…", 2500);
    setTimeout(() => { try { location.reload(); } catch (e) {} }, 900);
  }

Game.prototype.saveCreds = function () {
    if (!this.creds) return;
    if (this.spectating) this.creds.spec = true;
    else delete this.creds.spec;
    try { sessionStorage.setItem("wlkCreds", JSON.stringify(this.creds)); } catch (e) {}
  }

Game.prototype.clearCreds = function () {
    try { sessionStorage.removeItem("wlkCreds"); } catch (e) {}
  }

Game.prototype.loadCreds = function () {
    try {
      const raw = sessionStorage.getItem("wlkCreds");
      if (!raw) return null;
      const c = JSON.parse(raw);
      if (c && c.code && c.token) return c;
    } catch (e) {}
    return null;
  }

Game.prototype.tryResumeSession = function () {
    const c = this.loadCreds();
    if (!c) return false;
    this.creds = c;
    this.mode = "remote";
    this._intentionalClose = false;
    this._reconnectTries = 0;
    const nameInput = document.getElementById("nameInput");
    if (nameInput && c.name) nameInput.value = c.name;
    this.stopRoomPoll();
    this.hide("menu");
    this.attemptReconnect();
    return true;
  }

Game.prototype.reconnectActive = function () {
    if (!this.account || !this.activeGame) return;
    if (this.rejectIfAlphaClosed()) return;
    this.mode = "remote";
    this.testMode = false;
    this.spectating = false;
    this.clearRoundSpectate();
    this.spectateWatchId = null;
    this.spectateWatchPending = null;
    this.stopRoomPoll();
    Sound.stopAllFirewallLoops();
    this.players = []; this.projectiles = []; this.mines = []; this.sigils = []; this.healpods = []; this.blizzards = []; this.firewalls = []; this.hellrips = []; this.stickymines = []; this.icewalls = []; this.voidglass = []; this.nullSphereErupts = []; this.bossBeams = []; this.particles = []; this.snaps = [];
    this.shockwaves = []; this.beams = []; this.armPops = []; this.spellSpritePops = []; this.meteorCraters = []; this.floorBurns = []; this.bloodStains = []; this.plagueStains = []; this.frostStains = []; this.meteorNukeClouds = []; this.meteorNukeSwamps = []; this.meteorNukeFuses = [];
    this._intentionalClose = false;
    this.creds = null;
    this._reconnectTries = 0;
    const name = (document.getElementById("nameInput").value || "").trim();
    const title = equippedTitleId(this.account);
    if (this.net) this.net.close();
    this.net = new Net(this, (m) => this.onServerMsg(m));
    this.net.connect();
    this.net.send({ t: "rejoinactive", name, title });
    const el = document.getElementById("reconnecting");
    if (el) {
      el.textContent = "Reconnecting…";
      el.classList.remove("hidden");
    }
    this.hide("menu");
    this.hide("findGame");
    clearTimeout(this._reconnTO);
    this._reconnTO = setTimeout(() => { if (this.net) this.net.close(); }, 2800);
  }

Game.prototype.abandonActiveGame = async function () {
    if (!this.account || !this.activeGame) return;
    const ok = await showConfirm({
      title: "Leave game?",
      body: "You will forfeit your seat. Other players can continue without you.",
      okText: "Leave game",
      cancelText: "Cancel",
    });
    if (!ok) return;
    try {
      await fetch("/game/leave", { method: "POST", credentials: "same-origin" });
    } catch (e) { /* ignore */ }
    this.activeGame = null;
    this.renderActiveGame();
    this.showToast("Left the game.");
  }

Game.prototype.pingPresence = function () {
    fetch("/presence", {
      method: "POST",
      headers: { "X-Wlk-Tab-Id": tabPresenceId() },
      cache: "no-store",
    }).catch(() => {});
  }

Game.prototype.startPresenceHeartbeat = function () {
    if (this._presenceBeat) return;
    bindTabPresenceUnload();
    this.pingPresence();
    this._presenceBeat = setInterval(() => this.pingPresence(), 15000);
    if (!this._presenceVisBound) {
      this._presenceVisBound = true;
      document.addEventListener("visibilitychange", () => {
        if (!document.hidden) this.pingPresence();
      });
    }
  }

Game.prototype.fetchPlayersOnline = async function () {
    try {
      const res = await fetch("/online", { cache: "no-store" });
      if (!res.ok) return;
      const data = await res.json();
      // A deploy bumps the asset version; menu clients poll this, so catch a
      // stale frontend here and reload before starting a match. maybeApplyFeUpdate
      // only reloads outside an active match, so this is a no-op for in-game tabs.
      if (data.build) this.checkFeVersion(data.build);
      this._onlineStats = {
        players: data.players,
        inGame: data.inGame,
        inQueue: data.inQueue,
      };
      this.updatePlayersOnlineDisplay();
    } catch (e) { /* keep last counts */ }
  }

Game.prototype.startPlayersOnlinePoll = function () {
    if (this._onlinePoll) return;
    this.fetchPlayersOnline();
    this._onlinePoll = setInterval(() => this.fetchPlayersOnline(), 2500);
    this.updatePlayersOnlineDisplay();
  }

Game.prototype.formatOnlineCount = function (n) {
    return Number.isFinite(n) ? String(Math.max(0, Math.round(n))) : "—";
  }

Game.prototype.updatePlayersOnlineDisplay = function () {
    const s = this._onlineStats;
    const online = document.getElementById("playersOnlineCount");
    const inGame = document.getElementById("playersInGameCount");
    if (online) online.textContent = this.formatOnlineCount(s && s.players);
    if (inGame) inGame.textContent = this.formatOnlineCount(s && s.inGame);
    const mmOnline = document.getElementById("mmStatOnline");
    const mmInGame = document.getElementById("mmStatInGame");
    if (mmOnline) mmOnline.textContent = this.formatOnlineCount(s && s.players);
    if (mmInGame) mmInGame.textContent = this.formatOnlineCount(s && s.inGame);
  }

Game.prototype.startRoomPoll = function () {
    this.stopRoomPoll();
    this.fetchRooms();
    this._roomPoll = setInterval(() => this.fetchRooms(), 2500);
    this.startPlayersOnlinePoll();
  }

Game.prototype.stopRoomPoll = function () {
    if (this._roomPoll) { clearInterval(this._roomPoll); this._roomPoll = null; }
    this.stopMMPoll();
  }

Game.prototype.startMMPoll = function () {
    this.stopMMPoll();
    this.fetchMMRooms();
    this._mmPoll = setInterval(() => this.fetchMMRooms(), 2500);
    this.startPlayersOnlinePoll();
  }

Game.prototype.stopMMPoll = function () {
    if (this._mmPoll) { clearInterval(this._mmPoll); this._mmPoll = null; }
  }

Game.prototype.fetchMMRooms = async function () {
    let rooms;
    try {
      const res = await fetch("/matchmaking", { cache: "no-store", credentials: "same-origin" });
      if (!res.ok) return;
      rooms = await res.json();
    } catch (e) { return; }
    if (this.state !== "menu" || this.homeView !== "home") { this.stopMMPoll(); return; }
    this.renderMMWatchList(Array.isArray(rooms) ? rooms : []);
  }

Game.prototype.renderMMWatchList = function (rooms) {
    const wrap = document.getElementById("mmWatchList");
    if (!wrap) return;
    wrap.innerHTML = "";
    const byCode = new Map();
    for (const r of rooms) {
      if (!r || r.status !== "live" || !r.code) continue;
      byCode.set(r.code, r);
    }
    const live = [...byCode.values()];
    if (!live.length) {
      wrap.innerHTML = `<div class="room-empty">No live matches</div>`;
      return;
    }
    live.sort((a, b) => (a.host || "").localeCompare(b.host || ""));
    for (const r of live) {
      const row = document.createElement("div");
      row.className = "room-row";
      const round = r.round ? ` · r${r.round}/${r.rounds}` : "";
      const bots = r.bots ? ` · ${r.bots} bots` : "";
      row.innerHTML =
        `<div class="room-meta">` +
          `<span class="room-host">${escapeHtml(r.host || "Match")}</span>` +
          `<span class="room-stats">${r.players} players${bots}${round}</span>` +
        `</div>`;
      const btn = document.createElement("button");
      btn.className = "alt-btn room-watch";
      btn.textContent = "WATCH";
      btn.onclick = () => { Sound.resume(); this.saveName(); this.goOnline("join", r.code, { spectate: true }); };
      row.appendChild(btn);
      wrap.appendChild(row);
    }
  }

Game.prototype.fetchRooms = async function () {
    let rooms;
    try {
      const res = await fetch("/rooms", { cache: "no-store" });
      if (!res.ok) return;            // transient: keep the current list
      rooms = await res.json();
    } catch (e) { return; }           // offline/blip: leave list as-is
    if (this.state !== "menu" || this.homeView !== "find") { this.stopRoomPoll(); return; }
    this.renderRoomList(Array.isArray(rooms) ? rooms : []);
  }

Game.prototype.renderRoomList = function (rooms) {
    const lobbyWrap = document.getElementById("lobbyList");
    const liveWrap = document.getElementById("spectateList");
    if (!lobbyWrap || !liveWrap) return;
    const lobbies = rooms.filter((r) => r.status !== "live");
    const live = rooms.filter((r) => r.status === "live");
    const render = (wrap, list, emptyText, buildRow) => {
      wrap.innerHTML = "";
      if (!list.length) {
        wrap.innerHTML = `<div class="room-empty">${emptyText}</div>`;
        return;
      }
      list.sort((a, b) => (a.host || "").localeCompare(b.host || ""));
      for (const r of list) wrap.appendChild(buildRow(r));
    };
    render(lobbyWrap, lobbies, "No open lobbies — create one!", (r) => {
      const row = document.createElement("div");
      row.className = "room-row";
      row.innerHTML =
        `<div class="room-meta">` +
          `<span class="room-host">${escapeHtml(r.host || "Warlock")}'s game</span>` +
          `<span class="room-stats">${r.players}/${r.max} players · ${r.bots} bots · ${r.rounds} rounds</span>` +
        `</div>`;
      const watchBtn = document.createElement("button");
      watchBtn.className = "alt-btn room-watch";
      watchBtn.textContent = "SPECTATE";
      watchBtn.onclick = () => { Sound.resume(); this.saveName(); this.goOnline("join", r.code, { spectate: true }); };
      row.appendChild(watchBtn);
      const joinBtn = document.createElement("button");
      joinBtn.className = "alt-btn room-join";
      joinBtn.textContent = "JOIN";
      joinBtn.onclick = () => { Sound.resume(); this.saveName(); this.goOnline("join", r.code); };
      row.appendChild(joinBtn);
      return row;
    });
    render(liveWrap, live, "No live public matches right now.", (r) => {
      const row = document.createElement("div");
      row.className = "room-row";
      const round = r.round ? ` · round ${r.round}/${r.rounds}` : "";
      row.innerHTML =
        `<div class="room-meta">` +
          `<span class="room-host">${escapeHtml(r.host || "Warlock")}'s match</span>` +
          `<span class="room-stats">${r.players} players · ${r.bots} bots${round}</span>` +
        `</div>`;
      const btn = document.createElement("button");
      btn.className = "alt-btn room-watch";
      btn.textContent = "SPECTATE";
      btn.onclick = () => { Sound.resume(); this.saveName(); this.goOnline("join", r.code, { spectate: true }); };
      row.appendChild(btn);
      return row;
    });
  }
